'use client';

import HowItWorks from './HowItWorks';

export default HowItWorks;
